import { cva, type VariantProps } from 'class-variance-authority'

export const headingVariants = cva('text-ink', {
  variants: {
    variant: {
      display: 'font-mono text-5xl font-medium tracking-tight leading-none',
      h1: 'font-serif text-4xl font-medium tracking-tight leading-tight',
      h2: 'font-serif text-2xl font-semibold tracking-tight leading-snug',
      h3: 'font-serif text-xl font-semibold tracking-tight leading-snug',
      hero: 'font-serif text-[56px] font-semibold tracking-[-0.03em] leading-[1.07]',
      page: 'font-serif text-[52px] font-semibold tracking-[-0.03em] leading-[1.08]',
      section: 'font-serif text-[42px] font-semibold tracking-[-0.025em] leading-[1.1]',
      sectionCompact: 'font-serif text-[32px] font-semibold tracking-[-0.025em] leading-[1.1]',
      panel: 'font-serif text-[28px] font-semibold tracking-[-0.02em] leading-[1.2]',
      cardXl: 'font-serif text-[24px] font-semibold tracking-[-0.02em] leading-snug',
      cardLg: 'font-serif text-[22px] font-semibold tracking-[-0.02em] leading-snug',
      card: 'font-serif text-[20px] font-semibold tracking-[-0.02em] leading-snug',
      cardSm: 'font-serif text-[16px] font-semibold tracking-[-0.02em] leading-snug',
      eyebrow: 'font-sans text-[10px] font-semibold tracking-[0.12em] uppercase text-ink-3',
    },
  },
  defaultVariants: {
    variant: 'h2',
  },
})

export type HeadingVariantProps = VariantProps<typeof headingVariants>
